import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  messageMedia: {
    objectFit: "inherit",
    width: window.innerWidth > 630 ? 350 : 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  stickerMedia: {
    objectFit: "inherit",
    width: 150,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },
}))

export default useStyles
